import * as Yup from 'yup';
import { IBAN_INVALID_MESSAGE, isValidIban } from './iban';

/** Règle Yup partagée : IBAN requis et valide (la valeur du formulaire est déjà normalisée par IbanInput). */
export const requiredIbanSchema = Yup.string()
  .required("L'IBAN est requis")
  .test('iban', IBAN_INVALID_MESSAGE, value => isValidIban(value));
